import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'how-it-works';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { howItWorks: `content/pages/${ASSET_NAME}.json` };
  console.log("pageAsset",pageAsset)
  return dispatch(fetchPageAssets(pageAsset, true));
};
